// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var SectionTitle = function (x) {
    return x;
};
var tsBridgeSectionTitle = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("SectionTitle")("__brandSectionTitle"));
    }
};
var writeSectionTitle = Simple_JSON.writeForeignString;
var unwrap = function (v) {
    return v;
};
var showSectionTitle = Data_Show.showString;
var readSectionTitle = Simple_JSON.readString;
var ordSectionTitle = Data_Ord.ordString;
var newtypeSectionTitle = {
    Coercible0: function () {
        return undefined;
    }
};
var makeSectionTitle = SectionTitle;
var eqSectionTitle = Data_Eq.eqString;
export {
    SectionTitle,
    makeSectionTitle,
    unwrap,
    newtypeSectionTitle,
    eqSectionTitle,
    ordSectionTitle,
    showSectionTitle,
    readSectionTitle,
    writeSectionTitle,
    tsBridgeSectionTitle
};
//# sourceMappingURL=index.js.map
